import React, { useState, useEffect } from 'react';
import { getData, postData, serverURL } from '../../../../Services/Fetchnodeservices';

export default function PressReleaseManager() {
  const [pressReleases, setPressReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    rd: "",
    status: "1",
    hide: "0",
  });
  const [pic, setPic] = useState(null);
  const [preview, setPreview] = useState("");

  // Fetch all press releases on component mount
  useEffect(() => {
    fetchPressReleases();
  }, []);

  const fetchPressReleases = async () => {
    try {
      setLoading(true);
      const response = await getData("pressrelase/fetch_all_press_release");
      console.log("API Response:", response);
      if (response.status) {
        setPressReleases(response.data || []);
      } else {
        console.error("Failed to fetch:", response.message);
        setPressReleases([]);
      }
    } catch (error) {
      console.error("Error fetching press releases:", error);
      setPressReleases([]);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPic(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const resetForm = () => {
    setFormData({
      title: "",
      description: "",
      rd: "",
      status: "1",
      hide: "0",
    });
    setPic(null);
    setPreview("");
    setEditingId(null);
  };

  const handleSubmit = async () => {
    // Validation
    if (!formData.title.trim()) {
      alert("Please enter title");
      return;
    }
    if (!formData.description.trim()) {
      alert("Please enter description");
      return;
    }
    if (!formData.rd.trim()) {
      alert("Please enter RD");
      return;
    }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("rd", formData.rd);
      formDataToSend.append("status", formData.status);
      formDataToSend.append("hide", formData.hide);
      if (pic) {
        formDataToSend.append("pic", pic);
      }
      if (editingId) {
        formDataToSend.append("id", editingId);
      }

      const endpoint = editingId 
        ? "pressrelase/update_press_release" 
        : "pressrelase/add_press_release";
      
      const result = await postData(endpoint, formDataToSend);
      alert(result.message);

      if (result.status) {
        fetchPressReleases();
        setShowModal(false);
        resetForm();
      }
    } catch (e) {
      console.log(e);
      alert("Something went wrong");
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setFormData({
      title: item.title || "",
      description: item.description || "",
      rd: item.rd || "",
      status: item.status?.toString() || "1",
      hide: item.hide?.toString() || "0",
    });
    if (item.pic) {
      // Use imported serverURL consistently
      const imagePath = `${serverURL}/uploadnew/upload/${item.pic}`;
      console.log("Loading image from:", imagePath);
      setPreview(imagePath);
    } else {
      setPreview("");
    }
    setPic(null);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this press release?")) {
      try {
        const result = await postData("pressrelase/delete_press_release", { id });
        alert(result.message);
        if (result.status) {
          fetchPressReleases();
        }
      } catch (error) {
        console.error("Delete error:", error);
        alert("Failed to delete");
      }
    }
  };

  // Get image URL using imported serverURL
  const getImageUrl = (picPath) => {
    if (!picPath) return null;
    // Use imported serverURL consistently
    return `${serverURL}/uploadnew/upload/${picPath}`;
  };

  const getStatusBadge = (status) => {
    return status == 1 ? 
      <span style={styles.badgeActive}>Active</span> : 
      <span style={styles.badgeInactive}>Inactive</span>;
  };

  const getHideBadge = (hide) => {
    return hide == 1 ? 
      <span style={styles.badgeHidden}>Hidden</span> : 
      <span style={styles.badgeVisible}>Visible</span>;
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Press Release Management</h1>
        <button style={styles.addButton} onClick={() => {
          resetForm();
          setShowModal(true);
        }}>
          + Add Press Release
        </button>
      </div>

      {/* Table */}
      <div style={styles.tableWrapper}>
        {loading ? (
          <div style={styles.loading}>Loading...</div>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>ID</th>
                <th style={styles.th}>Image</th>
                <th style={styles.th}>Title</th>
                <th style={styles.th}>Description</th>
                <th style={styles.th}>RD</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Hide</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pressReleases.length === 0 ? (
                <tr>
                  <td colSpan="8" style={styles.noData}>No press releases found</td>
                </tr>
              ) : (
                pressReleases.map((item) => (
                  <tr key={item.id} style={styles.tr}>
                    <td style={styles.td}>{item.id}</td>
                    <td style={styles.td}>
                      {item.pic ? (
                        <div style={styles.imageContainer}>
                          <img 
                            src={getImageUrl(item.pic)}
                            alt={item.title}
                            style={styles.tableImage}
                            onError={(e) => {
                              console.log(`Image not found: ${getImageUrl(item.pic)}`);
                              e.target.style.display = 'none';
                              const parent = e.target.parentElement;
                              if (parent && !parent.querySelector('.error-message')) {
                                const errorSpan = document.createElement('span');
                                errorSpan.className = 'error-message';
                                errorSpan.style.color = '#999';
                                errorSpan.style.fontSize = '12px';
                                errorSpan.innerText = 'No Image';
                                parent.appendChild(errorSpan);
                              }
                            }}
                          />
                        </div>
                      ) : (
                        <span style={styles.noImage}>No image</span>
                      )}
                    </td>
                    <td style={styles.tdTitle}>{item.title}</td>
                    <td style={styles.tdDesc}>
                      {item.description?.length > 60 
                        ? `${item.description.substring(0, 60)}...` 
                        : item.description}
                    </td>
                    <td style={styles.td}>{item.rd}</td>
                    <td style={styles.td}>{getStatusBadge(item.status)}</td>
                    <td style={styles.td}>{getHideBadge(item.hide)}</td>
                    <td style={styles.td}>
                      <button style={styles.editBtn} onClick={() => handleEdit(item)}>Edit</button>
                      <button style={styles.deleteBtn} onClick={() => handleDelete(item.id)}>Delete</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal Popup */}
      {showModal && (
        <div style={styles.modalOverlay} onClick={() => setShowModal(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>{editingId ? "Edit Press Release" : "Add New Press Release"}</h2>
              <button style={styles.closeBtn} onClick={() => setShowModal(false)}>×</button>
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>Title *</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                style={styles.input}
                placeholder="Enter title"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Picture</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                style={styles.fileInput}
              />
              {preview && (
                <img 
                  src={preview} 
                  alt="Preview" 
                  style={styles.previewImage}
                />
              )}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Description *</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                style={styles.textarea}
                placeholder="Enter description"
                rows="4"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>RD (Release Date) *</label>
              <input
                type="text"
                name="rd"
                value={formData.rd}
                onChange={handleInputChange}
                style={styles.input}
                placeholder="e.g., 2024-01-15 or custom text"
              />
            </div>

            <div style={styles.row2col}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Status</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                  style={styles.select}
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Hide</label>
                <select
                  name="hide"
                  value={formData.hide}
                  onChange={handleInputChange}
                  style={styles.select}
                >
                  <option value="0">No (Visible)</option>
                  <option value="1">Yes (Hidden)</option>
                </select>
              </div>
            </div>

            <div style={styles.modalFooter}>
              <button style={styles.cancelBtn} onClick={() => setShowModal(false)}>Cancel</button>
              <button style={styles.submitBtn} onClick={handleSubmit}>
                {editingId ? "Update" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: "#f5f7fa",
    minHeight: "100vh",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "25px",
    flexWrap: "wrap",
    gap: "15px",
  },
  title: {
    fontSize: "28px",
    color: "#1a2a3a",
    margin: 0,
    fontWeight: "600",
  },
  addButton: {
    backgroundColor: "#0A84FF",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  tableWrapper: {
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "14px",
    minWidth: "900px",
  },
  th: {
    padding: "15px",
    textAlign: "left",
    backgroundColor: "#f8f9fa",
    borderBottom: "2px solid #dee2e6",
    fontWeight: "600",
    color: "#495057",
  },
  td: {
    padding: "12px 15px",
    borderBottom: "1px solid #e9ecef",
    verticalAlign: "middle",
  },
  tdTitle: {
    padding: "12px 15px",
    borderBottom: "1px solid #e9ecef",
    fontWeight: "500",
    maxWidth: "200px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  tdDesc: {
    padding: "12px 15px",
    borderBottom: "1px solid #e9ecef",
    maxWidth: "250px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#555",
  },
  tr: {
    transition: "background-color 0.2s",
  },
  imageContainer: {
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tableImage: {
    width: "50px",
    height: "50px",
    objectFit: "cover",
    borderRadius: "6px",
  },
  noImage: {
    color: "#999",
    fontSize: "12px",
  },
  badgeActive: {
    display: "inline-block",
    backgroundColor: "#d4edda",
    color: "#155724",
    padding: "4px 8px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "500",
  },
  badgeInactive: {
    display: "inline-block",
    backgroundColor: "#f8d7da",
    color: "#721c24",
    padding: "4px 8px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "500",
  },
  badgeHidden: {
    display: "inline-block",
    backgroundColor: "#e2d9f3",
    color: "#4a2c8a",
    padding: "4px 8px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "500",
  },
  badgeVisible: {
    display: "inline-block",
    backgroundColor: "#d1ecf1",
    color: "#0c5460",
    padding: "4px 8px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "500",
  },
  editBtn: {
    backgroundColor: "#ffc107",
    color: "#212529",
    border: "none",
    padding: "5px 12px",
    borderRadius: "6px",
    marginRight: "8px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "500",
    transition: "all 0.2s",
  },
  deleteBtn: {
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    padding: "5px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "500",
    transition: "all 0.2s",
  },
  noData: {
    textAlign: "center",
    padding: "40px",
    color: "#666",
  },
  loading: {
    textAlign: "center",
    padding: "40px",
    color: "#666",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "white",
    borderRadius: "16px",
    width: "90%",
    maxWidth: "600px",
    maxHeight: "90vh",
    overflowY: "auto",
    padding: "25px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    paddingBottom: "10px",
    borderBottom: "1px solid #eee",
  },
  modalTitle: {
    fontSize: "24px",
    color: "#1a2a3a",
    margin: 0,
  },
  closeBtn: {
    background: "none",
    border: "none",
    fontSize: "28px",
    cursor: "pointer",
    color: "#888",
    transition: "color 0.2s",
    padding: "0",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#333",
    fontSize: "14px",
  },
  row2col: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "14px",
    boxSizing: "border-box",
    transition: "border-color 0.2s",
    outline: "none",
  },
  textarea: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "14px",
    fontFamily: "inherit",
    resize: "vertical",
    boxSizing: "border-box",
    transition: "border-color 0.2s",
    outline: "none",
  },
  select: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "14px",
    backgroundColor: "white",
    transition: "border-color 0.2s",
    outline: "none",
  },
  fileInput: {
    width: "100%",
    padding: "8px 0",
  },
  previewImage: {
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "8px",
    marginTop: "10px",
    border: "1px solid #ddd",
  },
  modalFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "25px",
    paddingTop: "15px",
    borderTop: "1px solid #eee",
  },
  cancelBtn: {
    padding: "10px 20px",
    backgroundColor: "#f0f0f0",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.2s",
    color: "#333",
  },
  submitBtn: {
    padding: "10px 20px",
    backgroundColor: "#0A84FF",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.2s",
  },
};

// Add global styles
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  button:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  }
  input:focus, textarea:focus, select:focus {
    border-color: #0A84FF;
    box-shadow: 0 0 0 2px rgba(10,132,255,0.1);
  }
  tr:hover {
    background-color: #f8f9fa;
  }
`;
document.head.appendChild(styleSheet);